import React, { useCallback, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { apiFetch } from '../utils/api';
import PageHeader, { btnPrimary, cardClass } from '../components/PageHeader';
import { ACCOUNT_TYPE_LABELS } from '../utils/statusConstants';

const Accounts = () => {
  const [accounts, setAccounts] = useState([]);
  const [showInactive, setShowInactive] = useState(false);
  const [loading, setLoading] = useState(true);

  const load = useCallback(() => {
    setLoading(true);
    apiFetch(`/admin/accounts?include_inactive=${showInactive}`)
      .then((r) => setAccounts(r.data || []))
      .finally(() => setLoading(false));
  }, [showInactive]);

  useEffect(() => {
    load();
  }, [load]);

  return (
    <div>
      <PageHeader
        title="Accounts"
        subtitle="B2B property managers and residential customers"
        action={
          <Link to="/accounts/new" className={btnPrimary}>
            New account
          </Link>
        }
      />

      <label className="flex items-center gap-2 text-sm text-slate-600 mb-4">
        <input
          type="checkbox"
          checked={showInactive}
          onChange={(e) => setShowInactive(e.target.checked)}
        />
        Show inactive
      </label>

      <div className={cardClass}>
        <table className="w-full text-sm">
          <thead className="bg-slate-50 text-slate-600 text-left">
            <tr>
              <th className="px-5 py-3">Name</th>
              <th className="px-5 py-3">Type</th>
              <th className="px-5 py-3">Billing email</th>
              <th className="px-5 py-3">Locations</th>
              <th className="px-5 py-3">Status</th>
              <th className="px-5 py-3" />
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan={6} className="px-5 py-8 text-center text-slate-500">
                  Loading…
                </td>
              </tr>
            ) : (
              accounts.map((a) => (
                <tr key={a.id} className="border-t border-slate-100">
                  <td className="px-5 py-3 font-medium text-slate-900">{a.name}</td>
                  <td className="px-5 py-3">
                    {ACCOUNT_TYPE_LABELS[a.account_type] || a.account_type}
                  </td>
                  <td className="px-5 py-3">{a.billing_email || '—'}</td>
                  <td className="px-5 py-3">{a.location_count ?? 0}</td>
                  <td className="px-5 py-3">
                    {a.is_active ? (
                      <span className="text-green-700">Active</span>
                    ) : (
                      <span className="text-slate-400">Inactive</span>
                    )}
                  </td>
                  <td className="px-5 py-3 text-right">
                    <Link to={`/accounts/${a.id}/edit`} className="text-teal-700 hover:underline">
                      Edit
                    </Link>
                  </td>
                </tr>
              ))
            )}
            {!loading && accounts.length === 0 && (
              <tr>
                <td colSpan={6} className="px-5 py-8 text-center text-slate-500">
                  No accounts yet
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Accounts;
